import React, { useEffect, useState } from 'react';
import { HighlightPlayer } from 'lvn-embed-api';
import { Box, useMediaQuery } from '@mui/material';
import PlayPauseButton from './PlayPauseButton';

function HighlightEmbed({ highlight, isPlaying, setIsPlaying, muted = false }) {
  const isMobile = useMediaQuery('(max-width:600px)');
  const [minimalPlayer, setMinimalPlayer] = useState();

  const handleReady = (player) => {
    // resets the player when it's ready
    player.on('ready', () => {
      if (isPlaying) {
        setIsPlaying(false);
      }
      // Set mute state on ready.
      try {
        if (muted) {
          player.mute();
        } else {
          player.unmute();
        }
      } catch (e) {
        // Prevent a crash-to-white-screen if the embedded player becomes unavailable.
        return;
      }
    });
    // resets the player when it ends
    player.on('ended', () => {
      setIsPlaying(false);
    });
  };

  useEffect(() => {
    console.log('highlight', highlight);
    const next = new HighlightPlayer({
        containerId: 'embed-minimal',
        highlightId: highlight.id,
        highlightOptions: {
          type: 'minimal',
          height: '100%',
          textColor: '#ffffff',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          highlightColor: highlight.color,
          fontSize: isMobile ? '13px' : '16px',
          scrolling: true,
          src: "https://origin-embed.cortico.ai/",
        },
        onReady: handleReady,
      });
    setMinimalPlayer(next);
    return () => {
      setMinimalPlayer(null);
    };
  }, [highlight]);

  const handlePlayToggle = () => {
    if (minimalPlayer) {
      setIsPlaying(!minimalPlayer.isPlaying);
    }
  };

  useEffect(() => {
    if (minimalPlayer) {
      if (minimalPlayer.isInitialized) {
        if (isPlaying) {
          minimalPlayer.play();
        } else {
          minimalPlayer.pause();
        }
      }
    }
  }, [isPlaying]);

  // Mute/unmute effect
  useEffect(() => {
    if (minimalPlayer && minimalPlayer.isInitialized) {
      try {
        if (muted) {
          minimalPlayer.mute();
        } else {
          minimalPlayer.unmute();
        }
      } catch (e) {
        // Prevent React from crashing due to an embed messaging failure.
        return;
      }
    }
  }, [muted, minimalPlayer]);

  const formatDuration = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = Math.round(seconds) % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (
    <>
      <div
        style={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          justifyContent: 'start',
          color: '#FFFFFF',
          gap: isMobile ? '.4rem' : '1rem',
          marginBottom: isMobile ? 0 : 2,
        }}
      >
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', marginBottom: isMobile ? 0 : 2,}}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
              <PlayPauseButton
                onClick={handlePlayToggle}
                highlight={highlight}
                isPlaying={isPlaying}
              />
              <span
                style={{ fontWeight: 'bold', marginRight: '1rem', fontSize: isMobile ? '0.85rem' : undefined }}
              >
                { highlight.speaker ? (
                  <span>{highlight.speaker}</span>
                ) : ( <span>Anonymous</span> )}
              </span>
              </div>
              {/* <span style={{ textAlign: 'right', fontWeight: 'bold' }}>
              {formatDuration(highlight.duration)}
            </span> */}
            </Box>
          <div style={{ flexGrow: 1, width: '100%', maxWidth: '100%', overflowX: 'hidden' }}
          id="embed-minimal">
          </div>
      </div>
    </>
  );
}

export default HighlightEmbed;
